import { t } from 'i18next'
import { TOptions } from '../../../types/generalType'
import { DataType } from 'ka-table/enums'
import { Column } from 'ka-table/models'

export const transportationSelectOptions: TOptions[] = [
  { value: '1', label: t('earthly') },
  { value: '2', label: t('aerial') },
]

export const PreviousCompanionsHeaderData = [
  { key: 'martyrNumber', title: t('martyrNumber') },
  { key: 'firstName', title: t('firstName') },
  { key: 'lastName', title: t('lastName') },
  { key: 'nationalCode', title: t('nationalCode') },
  { key: 'fatherName', title: t('fatherName') },
  { key: 'brithday', title: t('brithday') },
  { key: 'add', title: t('addToNewTrip') },
]
export const NewReservePilgrimHeaderData = [
  { key: 'martyrNumber', title: t('martyrNumber') },
  { key: 'firstName', title: t('firstName') },
  { key: 'lastName', title: t('lastName') },
  { key: 'nationalCode', title: t('nationalCode') },
  { key: 'fatherName', title: t('fatherName') },
  { key: 'brithday', title: t('brithday') },
  { key: 'remove', title: t('removeFromNewTrip') },
]

export const transportationStatusOptions: TOptions[] = [
  { value: '0', label: t('all') },
  { value: '1', label: t('earthly') },
  { value: '2', label: t('aerial') },
]

export const preReserveTableColumns: Column[] = [
  { key: 'tourKindType', title: t('tourKind'), dataType: DataType.String, width: 70 },
  { key: 'martyrNumber', title: t('martyrNumber'), dataType: DataType.String, width: 120 },
  {
    key: 'province',
    title: t('province'),
    dataType: DataType.String,
    width: 150,
  },
  {
    key: 'preReserveDate',
    title: t('preReserveDate'),
    dataType: DataType.Date,
    width: 150,
  },
  {
    key: 'leaderName',
    title: t('name'),
    dataType: DataType.String,
    width: 220,
  },
  {
    key: 'leaderMobileNumber',
    title: t('mobile'),
    dataType: DataType.String,
    width: 120,
  },
  {
    key: 'transportationType',
    title: t('transportation'),
    dataType: DataType.String,
    width: 100,
  },
  {
    key: 'preReservePaymentStatusText',
    title: t('preReservePaymentStatus'),
    dataType: DataType.String,
    width: 150,
  },
  {
    key: 'operation',
    isSortable: false,
    width: 70,
  },
]

export const myPaymentsTableColumn: Column[] = [
  {
    key: 'localDate',
    title: t('dateAndClock'),
    dataType: DataType.String,
    width: 150,
  },
  { key: 'amount', title: t('orderPrice'), dataType: DataType.String, width: 100 },
  { key: 'payAmount', title: t('paymentedPrice'), dataType: DataType.String, width: 100 },
  { key: 'rrn', title: t('rrn'), dataType: DataType.String, width: 100 },
  { key: 'cardNumber', title: t('originCardNumber'), dataType: DataType.String, width: 120 },
  {
    key: 'originBankName',
    title: t('originBankName'),
    dataType: DataType.String,
    width: 100,
  },
  {
    key: 'statusText',
    title: t('paymentStatus'),
    dataType: DataType.String,
    width: 100,
  },
  {
    key: 'operation',
    isSortable: false,
    width: 70,
  },
]
export const myPreReserveTableColumn: Column[] = [
  { key: 'tourKindType', title: t('tourKind'), dataType: DataType.String, width: 70 },
  { key: 'martyrNumber', title: t('martyrNumber'), dataType: DataType.String, width: 120 },
  {
    key: 'preReserveDate',
    title: t('preReserveDate'),
    dataType: DataType.Date,
    width: 150,
  },
  {
    key: 'transportationType',
    title: t('transportation'),
    dataType: DataType.String,
    width: 100,
  },
  {
    key: 'preReservePaymentStatusText',
    title: t('preReservePaymentStatus'),
    dataType: DataType.String,
    width: 150,
  },
  {
    key: 'operation',
    isSortable: false,
    width: 70,
  },
]

export const preReserveTransferDateTableColumns: Column[] = [
  {
    key: 'selection-cell',
    isSortable: false,
    width: 70,
  },
  { key: 'tourKindType', title: t('tourKind'), dataType: DataType.String, width: 70 },
  { key: 'martyrNumber', title: t('martyrNumber'), dataType: DataType.String, width: 120 },
  {
    key: 'province',
    title: t('province'),
    dataType: DataType.String,
    width: 150,
  },
  {
    key: 'preReserveDate',
    title: t('preReserveDate'),
    dataType: DataType.Date,
    width: 100,
  },
  {
    key: 'leaderName',
    title: t('name'),
    dataType: DataType.String,
    width: 220,
  },
  {
    key: 'leaderMobileNumber',
    title: t('mobile'),
    dataType: DataType.String,
    width: 120,
  },
  {
    key: 'transportationType',
    title: t('transportation'),
    dataType: DataType.String,
    width: 100,
  },
  {
    key: 'preReservePaymentStatusText',
    title: t('preReservePaymentStatus'),
    dataType: DataType.String,
    width: 150,
  },
]
